/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-icon[_ngcontent-%COMP%]{cursor:pointer;font-size:1.1em;margin-left:6px}"];
export { styles as styles };
